import { FC } from 'react';
import { CheckIcon, NotAllowedIcon, TimeIcon } from '@chakra-ui/icons';
import { Spinner } from '@chakra-ui/react';
import { PiiStatus } from '../../graphql/generated';
import { StatusLabel } from './status-label';

type PIIStatusProps = {
  status: PiiStatus;
};

export const PIIStatus: FC<PIIStatusProps> = ({ status }) => {
  switch (status) {
    case PiiStatus.AWAITING_APPROVAL:
      return (
        <StatusLabel
          label="Awaiting Approval"
          data-testid="awaiting-approval-status"
        >
          <TimeIcon color="orange.300" boxSize="16px" />
        </StatusLabel>
      );

    case PiiStatus.SCANNING:
      return (
        <StatusLabel label="Scanning" data-testid="scanning-status">
          <Spinner color="blue.500" size="sm" />
        </StatusLabel>
      );

    case PiiStatus.APPROVED:
      return (
        <StatusLabel label="Released" data-testid="approved-status">
          <CheckIcon color="green.500" />
        </StatusLabel>
      );

    case PiiStatus.EXCLUDED_FOLDER:
    case PiiStatus.EXCLUDED_USER:
    case PiiStatus.UNSUPPORTED:
      return (
        <StatusLabel label="Skipped" data-testid="skipped-status">
          <NotAllowedIcon color="gray.500" />
        </StatusLabel>
      );

    default:
      return null;
  }
};
